import page from './src/page';

export default page;


// WEBPACK FOOTER //
// ./src/components/page/index.js